import { BLTeam, INode } from '../../../general/model';
import { SortByInterface } from '../../../general/utils/useSort';
import { createAction } from '@reduxjs/toolkit';
import { Column, ConversionState } from './model';
import { CHNode, NodeLabel } from '../../../general/node';
import { CreativeFolderStrict } from '../../../general/modelCreativeFolder';
import { Genre, Intro } from '../../../general/apiScenarios';

export const lastNodeIDSelectedChanged = createAction<
  { nodeID: number },
  'creativeHub/fileManager/lastNodeIDSelectedChanged'
>('creativeHub/fileManager/lastNodeIDSelectedChanged');
export const firstNodeIDSelectedChanged = createAction<
  { nodeID: number },
  'creativeHub/fileManager/firstNodeIDSelectedChanged'
>('creativeHub/fileManager/firstNodeIDSelectedChanged');
export const selectedNodesChanged = createAction<
  { isSelected: boolean; nodes: CHNode[]; replace: boolean; folder: NodeLabel },
  'creativeHub/fileManager/selectedNodeIdsChanged'
>('creativeHub/fileManager/selectedNodeIdsChanged');
export const selectorChanged = createAction<
  { node: CHNode; isChecked: boolean; shift: boolean },
  'creativeHub/fileManager/SELECTOR_CHANGED'
>('creativeHub/fileManager/SELECTOR_CHANGED');
export const selectorAllChanged = createAction<
  { nodes: CHNode[]; newChecked: boolean; context: CHNode },
  'creativeHub/fileManager/SELECTOR_ALL_CHANGED'
>('creativeHub/fileManager/SELECTOR_ALL_CHANGED');
export const allDeselected = createAction<
  { folderID?: number },
  'creativeHub/fileManager/ALL_DESELECTED'
>('creativeHub/fileManager/ALL_DESELECTED');
export const loadNodesStarted = createAction<void, 'creativeHub/fileManager/LOAD_NODES_STARTED'>(
  'creativeHub/fileManager/LOAD_NODES_STARTED',
);
export const loadNodesSuccess = createAction<
  { result: INode[]; loadedFolderNodeID: number },
  'creativeHub/fileManager/LOAD_NODES_SUCCESS'
>('creativeHub/fileManager/LOAD_NODES_SUCCESS');
export const loadNodesError = createAction<
  { error: any; loadedFolderNodeID: number },
  'creativeHub/fileManager/LOAD_NODES_ERROR'
>('creativeHub/fileManager/LOAD_NODES_ERROR');
export const nodeAdded = createAction<{ node: CHNode }, 'creativeHub/fileManager/nodeAdded'>(
  'creativeHub/fileManager/nodeAdded',
);
export const loadNodesRequested = createAction<
  { nodeID: number },
  'creativeHub/fileManager/LOAD_NODES_REQUESTED'
>('creativeHub/fileManager/LOAD_NODES_REQUESTED');
export const nodeRemoved = createAction<
  { node: Pick<CHNode, 'id'> },
  'creativeHub/fileManager/NODE_REMOVED'
>('creativeHub/fileManager/NODE_REMOVED');
export const nodePatched = createAction<
  { nodeID: number; patch: Partial<CHNode> },
  'creativeHub/fileManager/NODE_PATCHED'
>('creativeHub/fileManager/NODE_PATCHED');
export const refreshRequested = createAction<void, 'creativeHub/fileManager/REFRESH_REQUESTED'>(
  'creativeHub/fileManager/REFRESH_REQUESTED',
);
export const sortClicked = createAction<
  { sortBy: SortByInterface },
  'creativeHub/fileManager/SORT_CLICKED'
>('creativeHub/fileManager/SORT_CLICKED');

export const conversionStatusUpdated = createAction<
  Record<number, ConversionState>,
  'creativeHub/fileManager/conversionStatusUpdated'
>('creativeHub/fileManager/conversionStatusUpdated');
export const creativeInfoUpdated = createAction<
  { creatives: CreativeFolderStrict[] },
  'creativeHub/fileManager/creativeInfoUpdated'
>('creativeHub/fileManager/creativeInfoUpdated');
export const columnToggled = createAction<
  { columnID: Column; on?: boolean },
  'creativeHub/fileManager/columnToggled'
>('creativeHub/fileManager/columnToggled');
export const blTeamsLoaded = createAction<
  { teams: BLTeam[] },
  'creativeHub/fileManager/blTeamsLoaded'
>('creativeHub/fileManager/blTeamsLoaded');
export const allDeselectedExcept = createAction<
  { folderID: number },
  'creativeHub/fileManager/allDeselectedExcept'
>('creativeHub/fileManager/allDeselectedExcept');
export const blLoadingChanged = createAction<
  { blLoading: boolean },
  'creativeHub/fileManager/blLoadingChanged'
>('creativeHub/fileManager/blLoadingChanged');

export const loadGenresRequested = createAction<
  { project_id: number },
  'ch/fileManager/loadGenresRequested'
>('ch/fileManager/loadGenresRequested');
export const loadIntrosRequested = createAction<
  { project_id: number },
  'ch/fileManager/loadIntrosRequested'
>('ch/fileManager/loadIntrosRequested');
export const loadGenresUpdated = createAction<
  { genres: Genre[] },
  'ch/fileManager/loadGenresUpdated'
>('ch/fileManager/loadGenresUpdated');
export const loadIntrosUpdated = createAction<
  { intros: Intro[] },
  'ch/fileManager/loadIntrosUpdated'
>('ch/fileManager/loadIntrosUpdated');
